/*
 * @Author: jiangfeng
 * @Date: 2024-07-29 19:44:32
 * @LastEditTime: 2024-07-29 20:01:30
 * @LastEditors: jiangfeng
 * @FilePath: /governance-driver-projects/packages/acceptor-center/src/components/ui/dialog/js/animations.js
 */
// 所有动效接口都需要实现show和hide方法
// 且show和hide方法中的this指向一个dialog实例
import util from './util'

let Animations
let NoneAnimation = {
  show: false,
  hide: false
}

// pop动效
let PopAnimation = {
  // 参数cb为动效完成后的回调
  show (cb) {
    util.addClass(this.wrap, 'didi-dialog-pop-show')
    this.wrap.addEventListener('webkitAnimationEnd', () => {
      util.removeClass(this.wrap, 'didi-dialog-pop-show')
      if (typeof cb === 'function') cb()
    })
    this.wrap.addEventListener('animationEnd', () => {
      util.removeClass(this.wrap, 'didi-dialog-pop-show')
      if (typeof cb === 'function') cb()
    })
  },
  hide (cb) {
    util.addClass(this.wrap, 'didi-dialog-pop-hide')
    this.wrap.addEventListener('webkitAnimationEnd', () => {
      util.remove(this.container)
      if (typeof cb === 'function') cb()
    })
    this.wrap.addEventListener('animationEnd', () => {
      util.remove(this.container)
      if (typeof cb === 'function') cb()
    })
  }
}

// slide动效，for tips
let SlideAnimation = {
  show: function (cb) {
    //
    setTimeout(() => {
      util.addClass(this.content, 'didi-dialog-slide-show')
    }, 20)
    setTimeout(() => {
      util.removeClass(this.content, 'didi-dialog-slide-show')
      this.wrap.addEventListener('webkitTransitionEnd', () => {
        util.remove(this.container)
        if (typeof cb === 'function') cb()
      })
    }, this.cfg.timeout || 2000)
  },
  hide: function () {
    // do nothing
  }
}

let bottomSlideAnimation = {
  show (cb) {
    util.addClass(this.content, 'didi-dialog-slide-up')
    this.content.addEventListener('webkitAnimationEnd', () => {
      util.removeClass(this.wrap, 'didi-dialog-slide-up')
      if (typeof cb === 'function') cb()
    })
    this.content.addEventListener('animationEnd', () => {
      util.removeClass(this.wrap, 'didi-dialog-slide-up')
      if (typeof cb === 'function') cb()
    })
  },
  hide: function (cb) {
    util.addClass(this.content, 'didi-dialog-slide-down')
    this.content.addEventListener('webkitAnimationEnd', () => {
      setTimeout(() => {
        util.remove(this.container)
        if (typeof cb === 'function') cb()
      }, 100)
    })
    this.content.addEventListener('animationEnd', () => {
      setTimeout(() => {
        util.remove(this.container)
        if (typeof cb === 'function') cb()
      }, 100)
    })
  }
}

Animations = {
  none: NoneAnimation,
  pop: PopAnimation,
  slide: SlideAnimation,
  bottomSlide: bottomSlideAnimation
}

export default Animations
